import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';

import $ from 'jquery';

import axios from 'axios';
import Swal from 'sweetalert2';

import useAuth from '../../controllers/users/useAuth';
import {
    checkIfUserIsMaster, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, awaitDelay, separatorsNumbersSet, dataTableLanguaje, buttonProcessGet, processEvaluateGet,
    numberSet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { apartamentsGetAsync, buildingFloorsGet } from '../../controllers/apartments/apartments';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import Menu from '../main/Menu';
import AparmentAdd from './ApartmentAdd';
import BuildingHeader from '../buildings/BuildingHeader';
import ApartmentAliquoutPercentages from './ApartmentAliquoutPercentages';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';

const currentMethod = 'Apartments';

export default function Apartments({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    //#region others
    let result;
    let dataObj = {};
    let headerObj = {};
    let swalProperties = {};
    const auth = useAuth();
    const percentageValues = {
        empty: 0.00,
        full: 100.00,
    };
    //const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [processType, setProcessType] = useState(0);
    const [showLoading, setShowLoading] = useState({ header: true, body: true, });
    //const [showData, setShowData] = useState(false);
    const [showModalAliquot, setShowModalAliquot] = useState(false);
    const [aliquotPercentage, setAliquotPercentage] = useState(false);
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    //#endregion others

    //#region apartments
    //let apartmentsTwo = [];
    const btnApartmentAddId = 'btnApartmentAdd';
    const btnApartmentDeleteId = 'btnApartmentDeleteId';
    const dtApartmentsId = 'dtApartments';
    const [apartment, setApartment] = useState({});
    const [apartments, setApartments] = useState([]);
    const [apartmentsDt, setApartmentsDt] = useState([]);
    const [apartmentData, setApartmentData] = useState({ id: '', description: '', rowIndex: 0, });
    const [btnApartmentsSyncDisabled, setBtnApartmentsSyncDisabled] = useState(true);
    const [btnApartmentsAddDisabled, setBtnApartmentsAddDisabled] = useState(true);
    //#endregion apartments

    //#region buildings
    const buildingsId = 'buildings';
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    const [buildingFloors, setBuildingFloors] = useState([]);
    const [assignedAliquot, setAssignedAliquot] = useState(percentageValues?.empty);
    const [remainingAliquot, setRemainingAliquot] = useState(percentageValues?.empty);
    //#endregion buildings

    //#region others
    // const controls = {
    //     buttons: {
    //         add: {
    //             className: '',
    //             id: 'btnCreate',
    //         },
    //         aliquotAssigned: {
    //             className: '',
    //             id: 'btnCreate',
    //         },
    //         aliquotEraser: {
    //             className: '',
    //             id: 'btnCreate',
    //         },
    //     },
    //     checkBox: {
    //         // remenberMe: {
    //         //     attributes: {
    //         //     },
    //         //     id: 'chkRemenberMe',
    //         // },
    //     },
    //     dataTables: {
    //         buildings: {
    //             inputs: {
    //                 search: {
    //                     id: `${dtApartmentsId}_filter input`,
    //                     className: '',
    //                 },
    //             },
    //             selects: {
    //                 entries: {
    //                     id: `${dtApartmentsId}_length select`,
    //                     className: '',
    //                 },
    //             },
    //         },
    //     },
    //     icons: {
    //         create: {
    //             id: 'iconCreate',
    //             className: globalSettings?.icons?.plusCircle,
    //         },
    //     },
    //     inputs: {
    //         // email: {
    //         //     id: 'inputEmail',
    //         // },
    //         // password: {
    //         //     id: 'inputPassword',
    //         // },
    //     },
    //     spinners: {
    //         create: {
    //             id: 'spCreate',
    //             className: '',
    //         }
    //     },
    //     urls: {
    //         // forgotYourPassword: {
    //         //     id: 'urlForgotYourPassword',
    //         //     className: 'btn-link',
    //         // },
    //         // reCaptchaPrivaciConditions: {
    //         //     id: 'urlReCaptchaPrivaciConditions',
    //         //     className: '',
    //         // },
    //         // userRegister: {
    //         //     id: 'urlRequestAccount',
    //         //     className: '',
    //         // },
    //         // registerStatus: {
    //         //     id: 'urlStatusRegister',
    //         //     className: '',
    //         // },
    //     },
    // };
    //#endregion others
    //#endregion variables

    //#region apartments (methods)
    const apartamentsLocalGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartamentsLocalGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e?.preventDefault, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            setShowLoading({ header: false, body: true, });
            //setShowData(false);

            //#region variables
            let buildingLocal = buildingModelGet({});
            let apartmentsLocal = [apartmentModelGet({})];
            let apartmentsDtLocal = [];
            let isEditLocal = false;
            let isDeleteLocal = false;
            let remainingAliquotLocal = percentageValues?.empty;
            let assignedAliquotLocal = percentageValues?.empty; //localAliquotPercentageApartments
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //const currentMethod = 'Apartments / getApartamentsAsync';
            //#endregion variables

            //#region initialize
            setBuilding({});
            setAssignedAliquot(percentageValues?.empty);
            setRemainingAliquot(percentageValues?.empty);
            setBtnApartmentsSyncDisabled(true);
            setBtnApartmentsAddDisabled(true);
            //#endregion initialize

            $(`#${dtApartmentsId}`)?.DataTable()?.rows()?.clear()?.draw(true);

            //#region data get (apartments)
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings?.filter(({ id }) => id === buildingIdLocal)?.[0];
                if (!isUndNullEmp({ data: buildingLocal, subMethod: currentMethod, })?.result) {
                    response = await apartamentsGetAsync({
                        buildingId: buildingIdLocal,
                        auth: auth,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ header: false, body: false, });
                        //setShowData(false);
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return response;
                    }

                    apartmentsLocal = response?.result;
                    if (!isUndNullEmp({ data: apartmentsLocal, subMethod: currentMethod, })?.result && apartmentsLocal?.length > 0) {
                        apartmentsLocal?.forEach((detail) => {
                            //#region set apartment data
                            apartmentsDtLocal?.push([
                                detail?.identifier,
                                detail?.floor,
                                detail?.phoneNumber,
                                buttonProcessGet({
                                    id: detail?.id,
                                    description: detail?.identifier,
                                    showDetails: true,
                                    labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                                    enabledDetails: processEvaluateGet({
                                        object: detail,
                                        property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                        process: globalSettings?.labels?.detail?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    showEdit: true,
                                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                                    enabledEdit: processEvaluateGet({
                                        object: detail,
                                        property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                        process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    showDelete: true,
                                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                                    enabledDelete: processEvaluateGet({
                                        object: detail,
                                        property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                        process: globalSettings?.labels?.delete.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    processButtons: [],
                                    subMethod: currentMethod,
                                })?.result
                            ]);
                            //#endregion set apartment data

                            //#region calculate aliquot percentage
                            if (isUndNullEmp({ data: detail?.aliquotPercentage, subMethod: currentMethod, })?.result) {
                                detail.aliquotPercentage = percentageValues?.empty;
                            }

                            //#region old code
                            // assignedAliquotLocal = numberSet({
                            //     number: (assignedAliquotLocal + detail?.aliquotPercentage),
                            //     type: 'd',
                            //     languageId: languageObj?.id,
                            //     subMethod: currentMethod,
                            // })?.result;
                            //#endregion old code
                            assignedAliquotLocal += detail?.aliquotPercentage;
                            //#endregion calculate aliquot percentage
                        });

                        //#region set values aliquot percentage
                        assignedAliquotLocal = numberSet({
                            number: assignedAliquotLocal,
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                        remainingAliquotLocal = numberSet({
                            number: (percentageValues?.full - assignedAliquotLocal),
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                        setAssignedAliquot(assignedAliquotLocal);
                        setRemainingAliquot(remainingAliquotLocal);
                        //#endregion set values aliquot percentage

                        //#region check if add register is enabled
                        isEditLocal = processEvaluateGet({
                            object: apartmentsLocal?.[0],
                            property: globalSettings?.labels?.process?.en?.toLowerCase(),
                            process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;
                        isDeleteLocal = processEvaluateGet({
                            object: apartmentsLocal?.[0],
                            property: globalSettings?.labels?.process?.en?.toLowerCase(),
                            process: globalSettings?.labels?.delete?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;
                        //#endregion check if add register is enabled
                    } else {
                        //console?.log(buildingLocal);
                        //#region check if add register is enabled
                        //#region old code
                        // isEditLocal = processEvaluateGet({
                        //     object: apartmentsLocal?.[0],
                        //     property: globalSettings?.labels?.process?.en?.toLowerCase(),
                        //     process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                        //     subMethod: currentMethod,
                        // })?.result;
                        //#endregion old code
                        isEditLocal = (buildingLocal?.process?.edit || false) && (buildingLocal?.process?.delete || false);
                        isDeleteLocal = isEditLocal;
                        //#endregion check if add register is enabled
                    }
                    //#region set aliquot percentage
                    setAliquotPercentage(buildingLocal?.settings?.accountsReceivable?.aliquotPercentage);
                    //#endregion set aliquot percentage
                }
                setBuilding(buildingLocal);
                setBtnApartmentsSyncDisabled(false);
                setBtnApartmentsAddDisabled(!(isEditLocal && isDeleteLocal));
            }
            //#endregion data get (apartments)

            //#region dataTable set / load datatable
            //#region old code
            // response = dataTablesMethodSet(true, true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading({header: false, body: false,});
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }
            //#endregion old code

            $(`#${dtApartmentsId}`)?.DataTable()?.rows?.add(apartmentsDtLocal)?.draw(true);
            //#endregion dataTable set / load datatable

            setShowLoading({ header: false, body: false, });
            //setShowData(true);
        } catch (ex) {
            setShowLoading({ header: false, body: false, });
            //setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const apartmentAddGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentAddGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            setShowLoading({ header: false, body: true, });

            //#region check building
            if (isUndNullEmp({ data: building, subMethod: currentMethod, })?.result) {
                setShowLoading({ header: false, body: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: globalSettings?.messages?.youMustSelectBuilding?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                $(`#${buildingsId}`)?.trigger('focus');
                return
            }
            //#endregion check building

            //#region building floors
            response = buildingFloorsGet({
                building: building,
                setBuildingFloors: setBuildingFloors,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ header: false, body: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion building floors

            //#region data set
            setProcessType(0);
            setApartment(apartmentModelGet({
                buildingId: building?.id,
                floor: -1,
                userId: auth?.user?.uid,
            }));
            //#endregion data set

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            setShowModal(true);
            setShowLoading({ header: false, body: false, });
        } catch (ex) {
            setShowLoading({ header: false, body: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const apartmentEditDetailGetAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, processType_ = 0, subMethod = '', }) => {
        const currentMethod = 'apartmentEditDetailGetAsync';
        let response = responseGet();
        try {
            if (processType_ >= 1 && processType_ <= 2) {
                setShowLoading({ header: false, body: true, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            }

            switch (processType_) {
                case 1:
                    window.location.href = `${globalSettings?.app?.backend?.urlApartmentEdit}/${id}`;
                    break;
                case 2:
                    window.location.href = `${globalSettings?.app?.backend?.urlApartmentDetails}/${id}`;
                    break;
                default:
                    break;
            }

            setShowLoading({ header: false, body: false, });
        } catch (ex) {
            setShowLoading({ header: false, body: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const apartmentAliquoutsGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentAliquoutsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let apartmentsDtLocal = [];
            let apartmentsLocal = [apartmentModelGet({})];
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            e?.preventDefault();

            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                setShowLoading({ header: false, body: true, });
                //#region data get (apartments)
                response = await apartamentsGetAsync({
                    buildingId: buildingIdLocal,
                    auth: auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ header: false, body: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                apartmentsLocal = response?.result;
                setApartments(apartmentsLocal);

                if (!isUndNullEmp({ data: apartmentsLocal, subMethod: currentMethod, })?.result && apartmentsLocal?.length > 0) {
                    apartmentsLocal?.map((detail) => (
                        apartmentsDtLocal?.push([
                            detail?.floor,
                            detail?.identifier,
                            separatorsNumbersSet({
                                number: detail?.aliquotPercentage,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result,
                        ])
                    ));
                    setApartmentsDt(apartmentsDtLocal);
                }
                //#endregion data get (apartments)

                setShowModalAliquot(true);
                setShowLoading({ header: false, body: false, });
            }
        } catch (ex) {
            setShowLoading({ header: false, body: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const apartmentDeleteGetAsync = async ({ id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'apartmentDeleteGetAsync';
        let response = responseGet();
        try {
            //#region data set
            setApartmentData({
                id: id,
                description: description,
                rowIndex: rowIndex,
            });
            //#endregion data set

            $(`#${btnApartmentDeleteId}`)?.trigger('click');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentDeletePostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentDeletePostAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            if (!isUndNullEmp({ data: apartmentData, subMethod: currentMethod, })?.result) {
                //#region variables
                let idLocal = apartmentData?.id;
                let rowIndexLocal = apartmentData?.rowIndex;
                let description = apartmentData?.description;
                let apartmentLocal = apartmentModelGet({});
                let assignedAliquotLocal = percentageValues?.empty;
                let remainingAliquotLocal = percentageValues?.empty;
                //#endregion variables

                //#region old code
                //#region show message
                // swalProperties = {
                //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                //     title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                //     html: `${globalSettings?.labels?.apartment?.[languageObj?.id]}: <b>${description}</b><br/>${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                //     timer: null,
                //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
                //     confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                //     showCancelButton: true,
                //     cancelButtonColor: globalSettings?.colors?.successColorExp,
                //     cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                //     didOpen: () => {
                //         Swal.hideLoading();
                //     },
                // };

                // const { isConfirmed, } = await Swal.fire(swalProperties);
                //#endregion show message

                //#region delete data
                // if (isConfirmed) {
                //     sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

                //     headerObj = {
                //         headers: {
                //             authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                //         },
                //     };

                //     //result = await axios.delete(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartments}/${localId}`, headerObj);
                //     result = await axios.delete(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartments}/${idLocal}`, headerObj);
                //     response = result.data;

                //     if (!response?.isSuccess || response?.isWarning) {
                //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
                //         return;
                //     }

                //     apartmentLocal = response.result;

                //     $(`#${dtApartmentsId}`)?.DataTable()?.row(rowIndexLocal)?.remove()?.draw(true);

                //     //#region update aliquot assigned / remaining

                //     if (!isUndefined(apartmentLocal) && !isNull(apartmentLocal) && !isEmpty(apartmentLocal)) {
                //         if (!isUndefined(apartmentLocal.aliquotPercentage) && !isNull(apartmentLocal.aliquotPercentage)) {
                //             assignedAliquotLocal = numberSet((assignedAliquot - apartmentLocal.aliquotPercentage), 'd').result;
                //             remainingAliquotLocal = numberSet((percentageFullValue - assignedAliquotLocal), 'd').result;
                //             setAssignedAliquot(assignedAliquotLocal);
                //             setRemainingAliquot(remainingAliquotLocal);
                //         }
                //     }

                //     //#endregion update aliquot assigned / remainig

                //     setApartmentData({
                //         id: '',
                //         description: '',
                //         rowIndex: 0,
                //     });

                //     sendMessage(0, globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
                // }
                //#endregion delete data
                //#endregion old code

                //#region show message
                let msgTextObj = {
                    one: `${globalSettings?.labels?.apartment?.[languageObj?.id]}: <b>${description}</b><br/>`,
                    two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                };

                swalProperties = {
                    icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                    title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                    html: `${msgTextObj?.one}${msgTextObj?.two}`,
                    timer: null,
                    backdrop: true,
                    confirmButtonColor: globalSettings?.colors?.warningColorExp,
                    confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                    showCancelButton: true, //!Swal.isLoading(), //true,
                    cancelButtonColor: globalSettings?.colors?.successColorExp,
                    cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                    showLoaderOnConfirm: true,
                    didOpen: () => {
                        Swal.hideLoading();
                    },
                    preConfirm: async () => {
                        try {
                            Swal.getCancelButton().hidden = true;
                            Swal?.update({
                                icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                                title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                                html: msgTextObj?.one,
                                showConfirmButton: false,
                            });

                            //#region delete data (apartment)
                            headerObj = {
                                headers: {
                                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                    languageId: languageObj?.id,
                                },
                                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartments}/${idLocal}`,
                            };

                            result = await axios?.delete(
                                headerObj?.url,
                                headerObj,
                            );

                            response = result.data;

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: (isUndNullEmp({ data: response?.msgTextHtml, subMethod: currentMethod })?.result ? response?.msgText : response?.msgTextHtml),
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                });
                                return;
                            }
                            //#endregion delete data (apartment)

                            //#region update aliquot assigned / remaining
                            if (!isUndNullEmp({ data: apartmentLocal?.aliquotPercentage, subMethod: currentMethod, })?.result) {
                                assignedAliquotLocal = numberSet({
                                    number: (assignedAliquot - apartmentLocal.aliquotPercentage),
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result;

                                remainingAliquotLocal = numberSet({
                                    number: (percentageValues?.full - assignedAliquotLocal),
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result;
                                setAssignedAliquot(assignedAliquotLocal);
                                setRemainingAliquot(remainingAliquotLocal);
                            }
                            //#endregion update aliquot assigned / remainig

                            setApartmentData({
                                id: '',
                                description: '',
                                rowIndex: 0,
                            });

                            //#region delete dataTable (elevator)
                            $(`#${dtApartmentsId}`)?.DataTable()?.row(rowIndexLocal)?.remove()?.draw(true);

                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            //#endregion delete dataTable (elevator)
                        } catch (ex) {
                            //#region Error
                            response.isSuccess = false;
                            response.msgType = -1;
                            response.msgText = `Method: ${currentMethod}<br/>`;
                            response.msgText += `Error: ${ex?.message}`;
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            //#endregion Error
                        }
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                };

                Swal.fire(swalProperties);
                //#endregion show message
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const aliqoutErasersAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'aliqoutErasersAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region variables
            //let msgText = '';
            //#endregion variables

            //#region old code
            // //#region show message
            // msgText = `${globalSettings?.messages?.allAssignedAliquotsWillBeDeleted?.[languageObj?.id]}<br/>`;
            // msgText += `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

            // swalProperties = {
            //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
            //     title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
            //     html: msgText,
            //     timer: null,
            //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
            //     confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
            //     showCancelButton: true,
            //     cancelButtonColor: globalSettings?.colors?.successColorExp,
            //     cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
            //     didOpen: () => {
            //         Swal.hideLoading();
            //     },
            // };

            // const { isConfirmed, } = await Swal.fire(swalProperties);

            // //#endregion show message

            // //#region update data

            // if (isConfirmed) {
            //     sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

            //     headerObj = {
            //         headers: {
            //             authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //         },
            //     };

            //     dataObj = {
            //         conditionals: [],
            //         ordersBy: [],
            //         methodName: globalSettings?.app?.backend?.methods?.apartments.aliquotErasers,
            //         buildingId: building.id,
            //     }

            //     //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartments}/`, localData, headerObj);
            //     result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartments}/`, dataObj, headerObj);
            //     response = result.data;

            //     if (!response?.isSuccess || response?.isWarning) {
            //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //         return;
            //     }

            //     setAssignedAliquot(percentageValues?.empty);
            //     setRemainingAliquot(percentageFullValue);

            //     sendMessage(0, globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            // }
            // //#endregion update data
            //#endregion old code

            //#region show message
            let msgTextObj = {
                one: `${globalSettings?.messages?.allAssignedAliquotsWillBeDeleted?.[languageObj?.id]}<br/>`,
                two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                            //html: msgTextObj?.one,
                            html: `${globalSettings?.messages?.deletingAssignedAliquots?.[languageObj?.id]}.`,
                            showConfirmButton: false,
                        });

                        //#region delete data (apartmentAliquotPercentage)
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };

                        dataObj = {
                            conditionals: [],
                            ordersBy: [],
                            method: globalSettings?.app?.backend?.methods?.apartments.aliquotErasers,
                            buildingId: building?.id,
                            languageId: languageObj?.id,
                            url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartments}/`,
                        }

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: (isUndNullEmp({ data: response?.msgTextHtml, subMethod: currentMethod })?.result ? response?.msgText : response?.msgTextHtml),
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            return;
                        }
                        //#endregion delete data (apartmentAliquotPercentage)

                        //#region update aliquot assigned / remaining
                        setAssignedAliquot(percentageValues?.empty);
                        setRemainingAliquot(percentageValues?.full);
                        //#endregion update aliquot assigned / remainig

                        //#region show message
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion show message
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            Swal.fire(swalProperties);
            //#endregion show message

        } catch (ex) {
            setShowLoading({ header: false, body: false, });
            //setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion apartments (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ header: true, body: true, });
            //setShowData(false);

            //#region dataTable set
            response = dataTablesMethodSet({
                dtApartments: true,
                queryCodeSet_: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ header: false, body: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTable set

            //#region data get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: globalSettings?.app?.backend?.urlHome,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ header: false, body: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion data get

            setShowLoading({ header: false, body: false, });
            //setShowData(true);
        } catch (ex) {
            setShowLoading({ header: false, body: false, });
            //setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesMethodSet = ({ dtApartments = false, queryCodeSet_ = false, subMethod = '', }) => {
        const currentMethod = 'dataTablesMethodSet';
        let response = responseGet();
        try {
            //#region dataTable set
            if (dtApartments) {
                response = dataTablesSet({
                    dtApartmentsId: dtApartmentsId,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
            //#endregion dataTable set

            //#region queryCode set
            if (queryCodeSet_) {
                response = queryCodeSet({
                    dtApartmentsId: dtApartmentsId,
                    auth: auth,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
            //#endregion queryCode set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataTablesSet = ({ dtApartmentsId = '', subMethod = '', }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            $(`#${dtApartmentsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: globalSettings?.labels?.identifier?.[languageObj?.id], width: '60%', },
                    { title: globalSettings?.labels?.floor?.[languageObj?.id], width: '15%', },
                    { title: globalSettings?.labels?.phone?.[languageObj?.id], width: '20%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[1, 'asc'], [0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtApartmentsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({ dtApartmentsId = '', auth = {}, subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region Method
            $(`#${dtApartmentsId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtApartmentsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod })?.result) {
                    //attribute = e.target.attributes.method;
                    method = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            //window.location.href = `${globalSettings?.app?.backend?.urlApartmentEdit}/${id}`;
                            apartmentEditDetailGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            //window.location.href = `${globalSettings?.app?.backend?.urlApartmentDetails}/${id}`;
                            apartmentEditDetailGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            apartmentDeleteGetAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion Method
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='process' process='apartments' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.apartments?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.apartments?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/*buildings*/}
                        <BuildingHeader buildingsId={buildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={btnApartmentsSyncDisabled}
                            methodGetAsync={apartamentsLocalGetAsync}
                            processType={0}
                            headerSectionValues={{}}
                            showLoading={showLoading?.header}
                            languageObj={languageObj} />

                        {/*apartments*/}
                        <div className='row'>
                            <div className='col-12'>

                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.body}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={globalSettings?.labels?.apartments?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.apartmentsLogo}></img> - {globalSettings?.labels?.apartments?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*card body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                <div>
                                                    <button id={btnApartmentAddId}
                                                        disabled={btnApartmentsAddDisabled}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.create?.[languageObj?.id]}
                                                        className='btn btn-outline-success float-right btn-sm'
                                                        onClick={(e) => apartmentAddGetAsync({ e: e, subMethod: 'btn - addApartment', })}>
                                                        <i className={globalSettings?.icons?.plusCircle}></i>
                                                    </button>
                                                    <button id={btnApartmentDeleteId}
                                                        disabled={btnApartmentsAddDisabled}
                                                        hidden
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.delete?.[languageObj?.id]}
                                                        className='btn btn-outline-danger float-right btn-sm mx-1'
                                                        onClick={(e) => apartmentDeletePostAsync({ e: e, subMethod: 'btn - delete', })}>
                                                        <i className={globalSettings?.icons?.trash}></i>
                                                    </button>
                                                    <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                        <table id={dtApartmentsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                    </div>
                                                </div>
                                                {/* :
                                                        <div></div>
                                                    } */}
                                            </div>
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={globalSettings?.colors?.infoColorExp}
                                                    msgText={globalSettings?.messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>
                                    </div> {/*card body*/}

                                    {/* {showData ? */}
                                    <div className=''>
                                        {/*footer*/}
                                        <div className='card-footer'>
                                            {aliquotPercentage ?
                                                <div className='row'>
                                                    <div className='col-sm-4'>
                                                        <div className='description-block border-right'>
                                                            <span className='description-percentage text-primary'><i className={globalSettings?.icons?.checkCircle} /> {
                                                                separatorsNumbersSet({
                                                                    number: assignedAliquot,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: 'label - assignedAliquot',
                                                                })?.result
                                                            }%</span>
                                                            <h5 className='description-header'>{globalSettings?.labels?.assignedAliquot?.[languageObj?.id]}</h5>
                                                            <span className='description-text'></span>
                                                        </div>
                                                    </div>

                                                    <div className='col-sm-4'>
                                                        <div className='description-block border-right'>
                                                            <span className='description-percentage text-success'><i className={globalSettings?.icons?.checkCircle} /> {
                                                                separatorsNumbersSet({
                                                                    number: remainingAliquot,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: 'label - assignedAliquot',
                                                                })?.result
                                                            }%</span>
                                                            <h5 className='description-header'>{globalSettings?.labels?.remainingAliquot?.[languageObj?.id]}</h5>
                                                            <span className='description-text'></span>
                                                        </div>
                                                    </div>

                                                    <div className='col-sm-4'>
                                                        <div className='description-block'>
                                                            <button className='btn btn-outline-secondary btn-sm mx-1'
                                                                disabled={!aliquotPercentage}
                                                                title={globalSettings?.labels?.assignedAliquots?.[languageObj?.id]}
                                                                onClick={(e) => apartmentAliquoutsGetAsync({ e: e, subMethod: 'btn - aliquotAssigned', })}>
                                                                <i className={globalSettings?.icons?.percentage} ></i>
                                                            </button>
                                                            <button className='btn btn-outline-warning btn-sm'
                                                                disabled={!(aliquotPercentage && (remainingAliquot !== percentageValues?.full))}
                                                                onClick={(e) => aliqoutErasersAsync({ e: e, subMethod: 'btn - aliquotErrases', })}
                                                                title={globalSettings?.labels?.aliquotErasers?.[languageObj?.id]}>
                                                                <i className={globalSettings?.icons?.eraser}></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div> :
                                                <></>
                                            }
                                        </div>

                                    </div>
                                    {/* :
                                        <div></div>
                                    } */}

                                </div>{/*card*/}

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {showModal &&
                !isUndNullEmp({ data: building, subMethod: currentMethod, })?.result &&
                !isUndNullEmp({ data: apartment, subMethod: currentMethod, })?.result ?
                <AparmentAdd $={$}
                    auth={auth}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    userRole={userRole}
                    building={building}
                    buildingFloors={buildingFloors}
                    apartment={apartment}
                    setApartment={setApartment}
                    dtApartmentsId={dtApartmentsId}
                    aliquotPercentage={{
                        assignedAliquot,
                        setAssignedAliquot,
                        remainingAliquot,
                        setRemainingAliquot,
                    }}
                    processType={processType}
                    percentageValues={percentageValues}
                    languageObj={languageObj} />
                :
                <></>
            }

            {showModalAliquot &&
                !isUndNullEmp({ data: building, subMethod: currentMethod, })?.result &&
                !isUndNullEmp({ data: apartments, subMethod: currentMethod, })?.result && apartments?.length > 0 &&
                !isUndNullEmp({ data: apartmentsDt, subMethod: currentMethod, })?.result && apartmentsDt?.length > 0 ?
                <ApartmentAliquoutPercentages $={$}
                    auth={auth}
                    processValues={{
                        apartments: apartments,
                        building: building,
                        apartmentsDt: apartmentsDt,
                        showModal: showModalAliquot,
                        setShowModal: setShowModalAliquot
                    }} />
                :
                <></>
            }
        </div>
    )
}